import { DtMedia } from '@ow/ditto-core'

const { validation, transformer } = DtMedia
// export { default as transformer } from './transformer'
// export { default as validation } from './validation'
export { default as Render } from './render'
export { config, filterSpec } from './config'
export { validation, transformer }
